import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { withIntl, IntlProps } from 'ha/i18n';

import { GenderValue, GenderFilterValue } from 'ha/types/SearchFilters';
import FilterCheckbox from './FilterCheckbox';

interface Props {
  gender: GenderFilterValue;
  onToggle: (type: string, selected: boolean) => void;
}

export const GenderFilter: React.SFC<Props & IntlProps> = ({
  gender,
  onToggle,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography variant="subheading">{T('Gender')}</Typography>
    <FilterCheckbox
      name={`${GenderValue.BOYS}-checkbox`}
      isActive={gender.includes(GenderValue.BOYS)}
      onToggle={(selected: boolean) => onToggle(GenderValue.BOYS, selected)}
      data-test-locator="Filter Male"
    >
      {T('Male')}
    </FilterCheckbox>
    <FilterCheckbox
      name={`${GenderValue.GIRLS}-checkbox`}
      isActive={gender.includes(GenderValue.GIRLS)}
      onToggle={(selected: boolean) => onToggle(GenderValue.GIRLS, selected)}
      data-test-locator="Filter Female"
    >
      {T('Female')}
    </FilterCheckbox>
  </React.Fragment>
);

export default withIntl(GenderFilter);
